import React from 'react';

const Loading = () => {
    return (
        <div className="loading">
        <h2 className="loadingMessage" 
        style={{ padding: ".5em", color: "white"
        }}
        >Fitness Tracker is Loading...</h2>
       <iframe src="https://giphy.com/embed/MEiZ5h8lOkM7rwideE" width="480" height="250" frameBorder="0" className="giphy-embed" allowFullScreen></iframe>
        </div>
    )
}

export default Loading;